import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const path = '../oldPages/banner-management/edit/index.html';

const links: Record<string, string> = {
  back: '/infoTrac/banner-management/list',
};

function BannerEdit() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleIframeLoad = () => {
      const iframeDocument = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;

      if (!iframeDocument) return;

      const back = iframeDocument.getElementById('backBtn');

      const openModal = iframeDocument.getElementsByClassName('openModal');
      const closeModal = iframeDocument.getElementsByClassName('closeModal');

      if (openModal.length) {
        for (let i = 0; i < openModal.length; i++) {
          openModal[i].addEventListener('click', () => {
            document.body.classList.add('lightbox-open');
          });
        }
      }

      if (closeModal.length) {
        for (let i = 0; i < closeModal.length; i++) {
          closeModal[i].addEventListener('click', () => {
            document.body.classList.remove('lightbox-open');
          });
        }
      }

      if (back) back.addEventListener('click', () => navigate(links.back));
    };

    if (iframeRef.current) iframeRef.current.addEventListener('load', handleIframeLoad);

    return () => {
      if (iframeRef.current) iframeRef.current.removeEventListener('load', handleIframeLoad);
    };
  }, [navigate]);

  return (
    <iframe ref={iframeRef} title="banner-edit" src={path} className="z-[100] relative" width="100%" height="800px" />
  );
}

export default BannerEdit;
